import Vue from 'vue'

const btnLoading = {
  state: {},
  mutations: {
    SET_LOADING: (state, data) => {
      const isObject =
        Object.prototype.toString.call(data) === '[object Object]'
      if (!isObject) return
      Object.keys(data).forEach(key => {
        Vue.set(state, key, data[key])
      })
    },
    CANCEL_LOADING: state => {
      Object.keys(state).forEach(key => {
        Vue.delete(state, key)
      })
    }
  },
  actions: {
    SetLoading ({ commit }, data) {
      commit('SET_LOADING', data)
    },
    CancelLoading ({ commit }, data) {
      commit('CANCEL_LOADING', data)
    }
  }
}
export default btnLoading




// WEBPACK FOOTER //
// ./src/store/modules/btnLoading.js